export const environment = {
    production: true,
    // PROTOCOL: 'http',
    //IP: '18.223.226.65/',
    PROTOCOL: 'https',
     IP: 'usinc.io/',
    API_PATHS: {
        ADMIN: 'api/usinc_super_admin',
        FRONTEND: 'api/frontend',
        USERS: 'api/frontend',
    },
};
